import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { Pagination } from 'src/app/model/interfaces/pagination';

@Component({
  selector: 'app-busqueda-proveedor',
  templateUrl: './busqueda-proveedor.component.html',
  styleUrls: ['./busqueda-proveedor.component.css']
})
export class BusquedaProveedorComponent implements OnInit {

  @Output() onSelect = new EventEmitter<any>();

  display: boolean = false;
  proveedores: any[] = [];
  loading: boolean = false;
  totalRecords: number = 0;

  // Filtros
  filterNombre: string = '';
  filterRuc: string = '';

  // Paginación actual
  currentPage: number = 0;
  pageSize: number = 10;

  constructor(private datosMaestrosService: DatosMaestrosService) { }

  ngOnInit(): void {
  }

  showDialog() {
    this.display = true;
    this.resetFilters();
  }

  closeDialog() {
    this.display = false;
  }

  resetFilters() {
    this.filterNombre = '';
    this.filterRuc = '';
    this.proveedores = [];
    this.totalRecords = 0;
  }

  search() {
    this.currentPage = 0; 
    this.loadData(0, this.pageSize);
  }

  loadCustomersLazy(event: LazyLoadEvent) {
    const page = event.first! / event.rows!;
    this.pageSize = event.rows!;
    this.loadData(page, this.pageSize);
  }

  loadData(page: number, pageSize: number) {
    this.loading = true;

    let query = '';
    let type: 'nombre' | 'ruc' = 'nombre';

    if (this.filterRuc) {
      query = this.filterRuc;
      type = 'ruc';
    } else if (this.filterNombre) {
      query = this.filterNombre;
      type = 'nombre';
    } else {
      this.loading = false;
      return;
    }

    const pagination: Pagination = {
      page: page,
      pageSize: pageSize
    };

    this.datosMaestrosService.searchProveedor(query, type, pagination).subscribe(
      (response) => {
        if (response.status === 'OK') {
          this.proveedores = response.respuesta.items;
          this.totalRecords = response.respuesta.pagination.totalItems;
        } else {
          this.proveedores = [];
          this.totalRecords = 0;
        }
        this.loading = false;
      },
      (error) => {
        console.error('Error buscando proveedores:', error);
        this.proveedores = [];
        this.totalRecords = 0;
        this.loading = false;
      }
    );
  }

  selectProveedor(proveedor: any) {
    this.onSelect.emit(proveedor);
    this.closeDialog();
  }
}
